import React from 'react';
import { bool, shape, string } from 'prop-types';

const Spraying = ({
  className = '',
  notUseClass = false,
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M10.4993 12H13.4993L14.8764 15.6467C15.1234 16.3008 14.6401 17 13.9409 17H10.0588C9.35971 17 8.87637 16.301 9.12318 15.647L10.4993 12ZM11.4993 14L10.9993 15H12.9993L12.4993 14H11.4993Z" fill="currentColor" />
    <path fillRule="evenodd" clipRule="evenodd" d="M10.9993 23L10.9993 19H12.9993L12.9993 23H10.9993Z" fill="currentColor" />
    <path fillRule="evenodd" clipRule="evenodd" d="M15.8314 21.0508L14.1673 18.5547L15.8314 17.4453L17.4955 19.9414L15.8314 21.0508Z" fill="currentColor" />
    <path fillRule="evenodd" clipRule="evenodd" d="M6.50321 19.9415L8.16731 17.4453L9.83141 18.5547L8.16731 21.0509L6.50321 19.9415Z" fill="currentColor" />
    <path fillRule="evenodd" clipRule="evenodd" d="M5.18866 3.58212C4.71489 2.92036 5.1879 2 6.00177 2H17.9966C18.8105 2 19.2835 2.92034 18.8097 3.5821L13.4993 11H10.4993L5.18866 3.58212ZM7.94236 4L11.5138 9H12.4845L16.056 4H7.94236Z" fill="currentColor" />
  </svg>
);

Spraying.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default Spraying;
